module.exports = __webpack_public_path__ + "img/erp_case2.cd7f4255.png";